/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Hero_H1_BeforeInputs */

const es_gift_hero_h1_before = /** @type {(inputs: Gift_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regala una aventura en el `)
};

const gl_gift_hero_h1_before = /** @type {(inputs: Gift_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agasalla unha aventura no `)
};

const en_gift_hero_h1_before = /** @type {(inputs: Gift_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give an adventure on the `)
};

/**
* | output |
* | --- |
* | "Give an adventure on the" |
*
* @param {Gift_Hero_H1_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_hero_h1_before = /** @type {((inputs?: Gift_Hero_H1_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Hero_H1_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_hero_h1_before(inputs)
	if (locale === "en") return en_gift_hero_h1_before(inputs)
	return es_gift_hero_h1_before(inputs)
});